import { Profile } from '../../../Types';
import {
  ConsolidatedContact,
  ContactStatusOptionsObject,
} from '../../../api/CoachingNotes/schema';

import { createConsolidatedContact } from '../../../api/Utils/helper';
import Storage from '../../../Util/Storage';
import moment from 'moment';
import DataState from '../../../Types/DataState';
import { ContactStatus } from '../../Dashboard/DashboardComponents/HmdDetails/types';

export const OUTLIER_INGRESS = 'outlier';

export function getFormClickstreamTag1AndTag2(
  ingress: string | null,
  isCCX?: boolean
): { 'data-csa-c-tag1': string; 'data-csa-c-tag2': string } {
  if (isCCX) {
    return {
      'data-csa-c-tag1': 'Dashboard',
      'data-csa-c-tag2': 'Historical CCX Details',
    };
  } else if (ingress === 'GalaxiaPlus') {
    return {
      'data-csa-c-tag1': 'GalaxiaPlus',
      'data-csa-c-tag2': 'Outlier Management Portal',
    };
  } else if (ingress === OUTLIER_INGRESS) {
    return {
      'data-csa-c-tag1': 'Dashboard',
      'data-csa-c-tag2': 'Outliers',
    };
  } else if (ingress === 'realtimeHMD') {
    return {
      'data-csa-c-tag1': 'Dashboard',
      'data-csa-c-tag2': 'RealTimeHMD',
    };
  } else {
    return {
      'data-csa-c-tag1': 'Team',
      'data-csa-c-tag2': 'Contact Table',
    };
  }
}

export const fetchContactStatus = (
  ingress: string | null,
  profile: Profile,
  cscEntityPrefix: string,
  date: { start: string; end: string },
  apiNaws: any,
  setContactStatusDetails: (contactStatus: ContactStatus) => void,
  setContactStatusDetailsState: (state: any) => void
) => {
  if (ingress === 'realtimeHMD') {
    const isTm = profile.directReports?.length > 0;
    const contactStatusVariables = apiNaws.prepareContactStatusQuery(
      profile.user.userID,
      cscEntityPrefix,
      isTm,
      isTm ? profile.directReports : [],
      moment(date.start).format('GGGG-WW'),
      moment(date.end).format('GGGG-WW')
    );

    apiNaws.getContactStatus(
      contactStatusVariables,
      setContactStatusDetails,
      setContactStatusDetailsState
    );
  }
};

export const handleRealtimeHMDContact = (
  contactId: string | undefined,
  ingress: string | null,
  contactList: ConsolidatedContact[],
  contactListState: any,
  contactStatusDetailsState: any,
  profile: Profile,
  cscEntityPrefix: string,
  contactStatusDetails: ContactStatus,
  setContactList: (contacts: ConsolidatedContact[]) => void,
  setContactListState: (state: any) => void
) => {
  if (contactId && ingress === 'realtimeHMD') {
    const contactExists = contactList.some(c => c.contactID === contactId);
    const storedContact = Storage.getItem('realTimeHMDContactForReview');
    if (
      contactListState === DataState.LOADED &&
      contactStatusDetailsState === DataState.LOADED &&
      !contactExists &&
      storedContact
    ) {
      setContactListState(DataState.LOADING);
      try {
        const parsedContact = JSON.parse(storedContact);

        const consolidatedContact = createConsolidatedContact(
          parsedContact,
          cscEntityPrefix,
          profile.user.userID,
          contactId
        );

        const contactStatus = contactStatusDetails.contactStatuses.find(
          (status: any) => status.commId === contactId
        );

        const mergedContact: ConsolidatedContact = {
          ...consolidatedContact,
          contactStatus:
            contactStatus?.contactStatus ||
            ContactStatusOptionsObject.NOTREVIEWED,
          formReviews: contactStatus?.formReviews,
        };
        setContactList([mergedContact]);
        setContactListState(DataState.LOADED);
      } catch (error) {
        console.error('Error handling realtime HMD contact:', error);
        setContactListState(DataState.ERROR);
      }
    }
  }
};
